import { useEffect } from "react";
import type { ClerkFailure } from "./clerk-errors";
import { shareInflight } from "./clerk-username";
import { shouldSendCode } from "./code-cooldown";
import { clearCodeSent, markCodeSent, readCodeSentAt } from "./code-sent";

export const useSendCodeOnce = (
  flow: string,
  enabled: boolean,
  send: () => Promise<{ error: ClerkFailure | null }>
): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }
    shareInflight(`code:${flow}`, async () => {
      if (!shouldSendCode(readCodeSentAt(flow), Date.now())) {
        return;
      }
      const { error } = await send();
      if (error) {
        clearCodeSent(flow);
        return;
      }
      markCodeSent(flow);
    }).catch(() => undefined);
  }, [enabled, flow, send]);
};
